import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import LoginPage from '../components/LoginPage.vue'
import CompanyPage from '../components/CompanyPage.vue'
import YachtPage from '../components/YachtPage.vue'
/*import SettingsPage from '../components/SettingsPage.vue'
import PageVideo from '../components/containers/PageVideo.vue'*/
import store from "../store/index.js";

const routes = [
  {
    path: '/',
    component: LoginPage
  },
  {
    path: '/home',
    component: HomePage
  },
  {
    path: '/page/:id',
    component: YachtPage,
		props: true
  },
  {
    path: '/company',
    component: CompanyPage,
		props: true
  },
/*  {
    path: '/settings',
    component: SettingsPage
  },
  {
    path: '/presentation/:section/:page',
    component: PagePresentation,
		props: true
  },
  */
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const logged = store.getters.isLogged
  const section = store.getters.section
  if (!logged || !section) {
    if (!section && to.path !== '/') next("/");
    else next();
  } else {
    //if (to.path !== '/' && to.path !== '/login') store.commit("SET_LOADING", true);
		next();
  }
});

/*
router.beforeEach((to, from, next) => {
	store.commit("SET_LOADING", true);
	next();
});

router.afterEach((to, from) => {
	//store.commit("SET_LOADING", false);
	store.dispatch("addLoading");
});*/

export default router
